import React, { FC, useCallback, useEffect } from 'react'
import { Layout } from 'components/Layout'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { ShopCompleteTemplate } from 'components/Templates'
import { push } from 'connected-react-router'
import { getStoreName } from 'reducks/store/selectors'
import { fetchStore, initStore } from 'reducks/store/operations'
import { db } from 'firebase/index'
import { initShop } from 'reducks/shop/operations'
import { initStocks } from 'reducks/stock/operations'
import { initConfirm } from 'reducks/confirm/operations'

const ShopEditInformationComplete: FC = () => {
  const dispatch = useDispatch()

  const name = useSelector((state: State) => getStoreName(state))
  const path = useSelector((state: State) => state.router.location.pathname)
  const isCompletePage = /\/admin\/shops\/.+\/information\/complete/.test(path)
  const id = isCompletePage ? path.split('/admin/shops/')[1].split('/information/complete')[0] : undefined

  useEffect(() => {
    if (!id || name !== '') return
    dispatch(fetchStore(db.collection('stores').doc(id)))
  }, [])

  const backToAdminTop = useCallback(() => {
    dispatch(push('/admin/shops'))
    dispatch(initConfirm())
    dispatch(initShop())
    dispatch(initStore())
    dispatch(initStocks())
  }, [dispatch])

  if (!id) return <></>

  return (
    <Layout title={`完了 | ${name}の基本情報を編集`}>
      <ShopCompleteTemplate
        iconPath={'/icon/done/shop.svg'}
        firstLabel={'店舗基本情報の編集が'}
        secondLabel={'完了しました'}
        backToTop={backToAdminTop}
      />
    </Layout>
  )
}

export default ShopEditInformationComplete
